import React, { useEffect, useState } from 'react';
import BulletinCalendar from 'components/molecules/bulletin_calendar';
import InSampleBulletinAlert from 'components/atoms/in_sample_bulletin_alert';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState, ProfileTypes } from 'store/modules/profile_store/types';
import moment from 'moment';
import { captalizeFirstLetter } from 'services/captalize';
import { BulletinsState } from 'store/modules/bulletins_store/types';
import OpenTutorial from 'components/atoms/open_tutorial';
import MarkAllBulletinsButton from 'components/molecules/mark_all_bulletins_button';

const Bulletin: React.FC = () => {
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const [selectedFilterId, setSelectedFilterId] = useState<number | null>(null);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { request } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: ProfileTypes.UPDATE_STORE_FIELDS });
    document.title = 'Boletins de Licitações - ConLicitação';
  }, []);

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row mb-4 px-md-4 py-4">
          <div className="col-md-12">
            {request.fetch_bulletin_filters.loaded && request.fetch_bulletin_content?.loaded && (
              <div className="d-md-flex d-block align-items-center mb-3">
                <h4 className="mb-1 mr-3">
                  Boletins de {captalizeFirstLetter(moment(currentDate).format('MMMM [de] YYYY'))}
                </h4>
                <OpenTutorial type="modal" source="bulletins" />
                <div className="ml-md-auto mt-2 mt-md-0">
                  <MarkAllBulletinsButton selectedFilterId={selectedFilterId} />
                </div>
              </div>
            )}
          </div>
          <div className="col-md-12">
            {profile.in_sample && <InSampleBulletinAlert />}
            <BulletinCalendar
              currentDate={currentDate}
              setCurrentDate={setCurrentDate}
              selectedFilterId={selectedFilterId}
              setSelectedFilterId={setSelectedFilterId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bulletin;
